<div class="custom-pagination">
  <button
    *ngFor="let item of pages; let i = index"
    [class]="item.type"
    [class.disabled]="isInactive(item)"
    [class.current]="isCurrent(item)"
    [tabindex]="isInactive(item) ? -1 : 0"
    [attr.aria-current]="isCurrent(item)"
    [attr.aria-disabled]="isInactive(item)"
    (click)="pageChange(item)"
  >
    {{ item.label }}
  </button>
</div>
